import { defineMessages } from 'react-intl-next';
export const mediaEditingMessages = defineMessages({
	aspectRatioSelectionOriginal: {
		id: 'editor.imageEditor.aspectRatio.original',
		defaultMessage: 'Original',
		description: 'Display this message when user selects original as their cropper aspect ratio',
	},
	aspectRatioSelectionCustom: {
		id: 'editor.imageEditor.aspectRatio.custom',
		defaultMessage: 'Custom',
		description: 'Display this message when user selects custom as their cropper aspect ratio',
	},
    aspectRatioSelectionSquare: {
		id: 'editor.imageEditor.aspectRatio.square',
		defaultMessage: 'Square',
		description: 'Display this message when user selects square as their cropper aspect ratio',
	},
    aspectRatioSelectionCircle: {
		id: 'editor.imageEditor.aspectRatio.circle',
		defaultMessage: 'Circle',
		description: 'Display this message when user selects circle as their cropper aspect ratio',
	},
    aspectRatioSelectionLandscape: {
		id: 'editor.imageEditor.aspectRatio.landscape',
		defaultMessage: 'Landscape',
		description: 'Display this message when user selects landscape as their cropper aspect ratio',
	},
    aspectRatioSelectionPortrait: {
		id: 'editor.imageEditor.aspectRatio.portrait',
		defaultMessage: 'Portrait',
		description: 'Display this message when user selects portrait as their cropper aspect ratio',
	},
    aspectRatioSelectionWide: {
		id: 'editor.imageEditor.aspectRatio.wide',
		defaultMessage: 'Wide',
		description: 'Display this message when user selects wide as their cropper aspect ratio',
	},
    squareButton: {
		id: 'editor.imageEditor.aspectRatio.squareButton',
		defaultMessage: 'Square 1:1',
		description: 'Square button display',
	},
    circleButton: {
		id: 'editor.imageEditor.aspectRatio.circleButton',
		defaultMessage: 'Circle 1:1',
		description: 'Circle button display',
	},
    landscapeButton: {
		id: 'editor.imageEditor.aspectRatio.landscapeButton',
		defaultMessage: 'Landscape 4:3',
		description: 'Landscape button display',
	},
    portraitButton: {
		id: 'editor.imageEditor.aspectRatio.portraitButton',
		defaultMessage: 'Portrait 3:4',
		description: 'Portrait button display',
	},
    wideButton: {
		id: 'editor.imageEditor.aspectRatio.wideButton',
		defaultMessage: 'Wide 16:9',
		description: 'Wide button display',
	},
    cancelButton: {
		id: 'editor.imageEditor.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button display',
	},
    doneButton: {
		id: 'editor.imageEditor.done',
		defaultMessage: 'Done',
		description: 'Done button display',
	},
});
